import React from "react";
import { FaFirefox } from "react-icons/fa";
import styles from "./successfulverification.module.css";
import appStoreIcon from "../../assets/app-store-png-logo-33109.png";
import playStoreIcon from "../../assets/play-store-logo-33874.png";
import responsiveDevices from "../../assets/responsivedevices.png";
import { isMobile } from "../../Utils";
import { ANDROID_APP_LINK, IOS_APP_LINK, APP_LINK_login } from "../../CONSTANTS"

function SuccessfulVerification() {

  return (
    <div className={[styles.success_container, "box-container"].join(" ")}>
      <div>
        <FaFirefox style={{ height: "100px", width: "100px" }} />
      </div>
      <div className={styles.success_title}>
        <span>Email verified</span>
      </div>
      <div className="box-container">
          {isMobile() ?
              <>
                  <img src={responsiveDevices} alt="" />
                  <p>Login to get started.</p>
                  <a href={APP_LINK_login} className="App-button-round-blue">
                      Go to login page
                  </a>
              </> : <>
                  <img src={responsiveDevices} alt="" />
                  <p>Download and open the app and login to get started.</p>
                  <a href={ANDROID_APP_LINK}>
                      <img src={appStoreIcon} alt="Android App" />
                  </a>
                  <a href={IOS_APP_LINK}>
                      <img src={playStoreIcon} alt="IOS app" />
                  </a>
              </>}
      </div>
    </div>
  );
}

export default SuccessfulVerification;
